<template>
<div class="wrapper" :class="{'sidebar-shown': displaySidebar, 'sidebar-open': sidebarOpen}">
  <sidebar active="0" @openSidebar="sidebarOpen = true" @closeSidebar="sidebarOpen = false"/>
  <main id="main" class="content has-sidebar">
    <header class="page">
      <h1 class="title">Getting Started</h1>
    </header>
    <form class="form">
      <div class="form-row">
        <label for="mix-name" class="form-label">Name your mix</label>
        <div class="input-group" :class="{ 'has-error': $v.name.$error, 'is-valid': $v.name.required }">
          <input id="mix-name" type="text" class="form-control" v-model.trim="$v.name.$model" autofocus>
          <div class="error" v-if="!$v.name.required">Please choose a name</div>
        </div>
      </div>
      <!-- <div class="form-row">
        <label for="mix-zip" class="form-label">Zip code</label>
        <div class="input-group is-smaller" :class="{ 'has-error': $v.zip.$error, 'is-valid': $v.zip.required && $v.zip.minLength }">
          <input id="mix-zip" type="tel" class="form-control" v-model.trim="$v.zip.$model" maxlength="5">
          <div class="error" v-if="!$v.zip.required">Zip code is required</div>
          <div class="error" v-if="!$v.zip.minLength">Invalid zip code length</div>
        </div>
      </div> -->
      <div class="form-row">
        <label for="mix-acres" class="form-label">Number of acres</label>
        <div class="input-group is-smaller" :class="{ 'has-error': $v.acres.$error, 'is-valid': $v.acres.required && $v.acres.decimal && $v.acres.minValue }">
          <input id="mix-acres" type="text" inputmode="decimal" class="form-control" v-model.trim="$v.acres.$model" autocomplete="off" autocorrect="off" autocapitalize="off">
          <div class="error" v-if="!$v.acres.required">Acres is required</div>
          <div class="error" v-if="!$v.acres.decimal && $v.acres.minValue">Invalid number format</div>
          <div class="error" v-if="!$v.acres.minValue">Minimum acres is 15.</div>
        </div>
      </div>
      <div class="form-row">
        <label class="form-label">Planting Method</label>
        <drop-down :items="this.$store.state.plantingMethods" :selected="this.$store.state.plantingMethods[plantingMethod]" @changed="plantingMethod = $event"></drop-down>
      </div>
      <div class="form-row">
        <label class="form-label">Packaging options</label>
        <div class="input-group is-radios" :class="{ 'has-error': $v.packagingOption.$error }">
          <label class="radio-label" :class="{'is-checked': packagingOption === 'Bags'}" for="packagingBags">
            <span>Bags</span>
            <input type="radio" class="form-radio" id="packagingBags" v-model.trim="$v.packagingOption.$model" value="Bags">
          </label>
          <label class="radio-label" :class="{'is-checked': packagingOption === 'Totes'}" for="packagingTotes">
            <span>Totes</span>
            <input type="radio" class="form-radio" id="packagingTotes" v-model.trim="$v.packagingOption.$model" value="Totes">
          </label>
          <label class="radio-label" :class="{'is-checked': packagingOption === 'Bulk'}" for="packagingBulk">
            <span>Bulk</span>
            <input type="radio" class="form-radio" id="packagingBulk" v-model.trim="$v.packagingOption.$model" value="Bulk">
          </label>
          <div class="error" v-if="!$v.packagingOption.required">Please choose an option</div>
        </div>
      </div>
      <div class="form-row">
        <button class="btn btn-primary has-arrow" :disabled="$v.$invalid" @click.prevent="handleNextButton">Next</button>
      </div>
      <p v-if="!$v.acres.minValue">If you'd like to order an amount to cover less than 15 acres, please use the bags found on <a href="https://www.millbornseeds.com/cover-crops/">our store</a>.</p>
    </form>
  </main>
</div>
</template>

<script>
import { required, minValue, decimal } from 'vuelidate/lib/validators'
import Sidebar from '@/components/Sidebar'
import Dropdown from '@/components/Dropdown'
export default {
  data () {
    return {
      submitStatus: null,
      displaySidebar: true,
      sidebarOpen: false
    }
  },
  components: {
    'sidebar': Sidebar,
    'drop-down': Dropdown
  },
  methods: {
    handleNextButton () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.$router.push({ name: 'planting-time' })
      }
    }
  },
  validations: {
    name: { required },
    // zip: { required, minLength: minLength(5) },
    acres: { required, decimal, minValue: minValue(15) },
    packagingOption: { required }
  },
  computed: {
    name: {
      get () {
        return this.$store.state.formData.mixName
      },
      set (value) {
        this.$store.commit('updateMixName', value)
      }
    },
    zip: {
      get () {
        return this.$store.state.formData.zip
      },
      set (value) {
        this.$store.commit('updateZip', value)
      }
    },
    acres: {
      get () {
        return this.$store.state.formData.acres
      },
      set (value) {
        this.$store.commit('updateAcres', value)
        this.$emit('updateTotals')
      }
    },
    packagingOption: {
      get () {
        return this.$store.state.formData.packagingOption
      },
      set (value) {
        this.$store.commit('updatePackagingOption', value)
      }
    },
    plantingMethod: {
      get () {
        return this.$store.state.formData.plantingMethod
      },
      set (value) {
        if (value !== this.$store.state.formData.plantingMethod) {
          this.$store.commit('showMixInstructions', true)
        }
        this.$store.commit('updatePlantingMethod', value)
      }
    }
  }
}
</script>
